import {Alert, AlertDescription, AlertTitle, Button, CloseButton} from "@chakra-ui/react";
import styled from "styled-components/macro";
import {useState} from "react";
import storage from "../utils/storage";
import {useModal} from "../store";
import Signup from "./signup";

const NewUser = styled.div`
  margin-bottom: 12px;
  border-radius: 4px;
  background: ${({theme}) => theme.color.name === 'dark' ? '#1a1a1b' : '#fff'};
  background: ${({theme}) => theme.color.name === 'dark' ? 'linear-gradient(45deg, rgba(26,26,27,1) 0%, rgba(42,42,51,1) 83%, rgba(57,57,75,1) 100%)'
          : 'linear-gradient(45deg, rgba(255,255,255,1) 0%, rgba(242,248,255,1) 83%, rgba(220,234,252,1) 100%)'};
  
  @media only screen and (max-width: 780px) {
    border-radius: 0px;
    border: none;
    margin-bottom: 0;
    margin: 6px 0;
  }
`;

const TITLE_MAPPING = {
    1: 'New to Scored?',
    2: 'Our politics policy.',
    3: 'Getting started.',
    4: 'Explore Trending',
};

const NewUserWelcome = ({setWelcomeDismissed}) => {

    const [page, setPage] = useState(parseInt(storage.getItem("has_onboarded")) || 1);
    const handleDone = async () => {
        storage.setItem("has_onboarded", 4);
        setWelcomeDismissed(4);
        close();
    };
    const modal = useModal();
    const handlePaginate = async () => {
        if (page >= 4) {
            await handleDone();
            modal.open(Signup);
        } else {
            storage.setItem("has_onboarded", page + 1);
            setPage(page + 1);
        }
    };

    return (
        <NewUser>
            <Alert
                status="success"
                variant="homefeed"
                flexDirection="column"
                justifyContent="center"
                alignItems="left"
                style={{padding: '24px'}}
            >
                <AlertTitle mb={1} fontSize="lg" fontWeight={500}>
                    {TITLE_MAPPING[page]}
                </AlertTitle>
                <AlertDescription maxWidth="sm" style={{fontSize: '15px', width: page === 3 || page === 2 ? '384px' : '320px', textAlign: 'left', maxWidth: 'calc(100% - 36px)'}}>
                    {page === 1 && <>Scored is a network of user-created communities, ranging from memes and animals to politics and more.</>}
                    {page === 2 && <>If a community hasn't tagged itself as political, then content relating to politics or social issues is not allowed.</>}
                    {page === 3 && <>Home contains posts from communities that you have joined.</>}
                    {page === 4 && <>Trending consists of all posts, with tools to exclude communities or entire topics.</>}
                </AlertDescription>
                {page === 4 && <CloseButton onClick={handleDone} position='absolute' right='8px' top='8px'/>}
                <Button variant={'blue'} mt={'16px'} onClick={handlePaginate} width='76px'>{page < 4 ? 'Next' : 'Sign Up'}</Button>
            </Alert>
        </NewUser>

    );
};

export default NewUserWelcome;
